import { render, staticRenderFns } from "./BusinessGrowthChart.vue?vue&type=template&id=f84e4112"
import script from "./BusinessGrowthChart.vue?vue&type=script&lang=js"
export * from "./BusinessGrowthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports